<nz-form-item>
    <nz-form-label>{{customField.name | cwtDictionary}}</nz-form-label>
    <nz-form-control>
        <input *ngIf="!customField.isMultiSelect" nz-input [disabled]="disabled" [(ngModel)]="value" [type]="customField.type" />
        <nz-select *ngIf="customField.isMultiSelect" [nzDisabled]="disabled" [(ngModel)]="value" nzMode="tags" [nzTokenSeparators]="[',', ';']"></nz-select>
    </nz-form-control>
</nz-form-item>